import TagPage from "./TagPage";

export default TagPage;
